<section class="row mb-2">
  <div class="col-md-4 col-xs-12"></div>
  <div class="col-md-4 col-xs-12"></div>
  <div class="col-md-4 col-xs-12 bc-Dash-Div">
    <a (click)='backToDashBoard()'>
      <img src='/icons/{{baseSiteId}}/chevron-left_green.svg' class="svg-Images" alt="left">
    Back to dashboard</a>
  </div>
</section>
<section class="container footer-Container-Section">

  <div class="row headerStrip pr-3">

    <div class="col-md-7 col-sm-7 col-xs-7 influenza-Contact-Section ml-3">
      <p class="enrollDetails topMargin">{{countofEnrolledStatus}} of your {{arrLength}} locations are enrolled</p>
    </div>
    <div class=" col-md-4 col-sm-4 col-xs-4 p-0 mt-2 ml-5 influenza-Contact-Section">
      <input type="text" class="form-control" placeholder="Search by location name, city, zip code"
        [(ngModel)]="searchText" id="locationSearch" (ngModelChange)="searchResult($event)"
        data-di-id="#locationSearch">
      <img [src]="'/icons/'+baseSiteId+'/search_new.svg'" alt="search_icon">
    </div>

  </div>



  <section class="row">
    <div class="vacc_loc">
      <section class=" col-md-12 col-sm-12 col-xs-12 influenza-Contact-Section">
        <p class="desc">Simplify influenza formula by enrolling your practice locations in recurring reservations. The
          same influenza vaccines will be reserved automatically each formula, and you'll simply have to confirm or edit
        the reservation. Manage enrollment and contact information at any time.</p>
        <div class="vacc_table">
          <table aria-describedby="locatorTable" id="vaccineLocatorTable" class="inflzTab_table table-striped">
            <thead>
              <tr>

                <th width="10%" scope="col" class="restCols">
                  <div class="row ml-0 pt-3">
                    <div class="col-md-2 radioAlign ipadAlign"><label>
                      @if (!locationSelectorOn) {
                        <input type="checkbox" id="checkBox" (click)="applySettingAll()"
                          data-di-id="#checkBox">
                      }
                      @if (locationSelectorOn) {
                        <input type="checkbox" id="checkBox" checked
                          (click)="applySettingAll()" data-di-id="#checkBox">
                      }
                      <span class="checkmark"></span>
                    </label></div>

                    <div class="col-md-10 topMargin" (click)="sortColumn($event, 'locationName', ordersList, 'normal')">
                      Location({{arrLength}})
                      <i class="my-icon fas fa-caret-down"></i>
                    </div>
                  </div>

                </th>

                <th scope="col" class="restCols2" (click)="sortColumn($event, 'addressID', ordersList, 'normal')">

                  Address

                  <i class="my-icon fas fa-caret-down"></i>

                </th>

                <th scope="col" class="restCols_phone">

                  Phone

                </th>

                <th scope="col" class="restCols3" (click)="sortColumn($event, 'addressID', ordersList, 'normal')">

                  Status

                  <i class="my-icon fas fa-caret-down"></i>

                </th>

                <th scope="col" class="restCols3_contact"
                  (click)="sortColumn($event, 'firstName', ordersList, 'normal')">

                  Reservation Contact

                  <i class="my-icon fas fa-caret-down"></i>

                </th>
                <th scope="col" class="restCols2 prefcontact-col"
                  (click)="sortColumn($event, 'email', ordersList, 'normal')">

                  Preferred Contact Method

                  <i class="my-icon fas fa-caret-down"></i>

                </th>

                <th scope="col" class="restEdit">



                </th>

              </tr>

            </thead>

            <tbody>

              @if (locationSelectorOn) {
                <tr>
                  <td class="locationSelector">
                    <span>All locations selected({{arrLength}})</span>
                    <div class="d-flex mt-4">
                      <button class="btn-secondary">
                        <a (click)="cancelAllLocation()">Cancel</a></button>
                        <button class="btn-primary ml-2 apply-btn-style" (click)="clickApplytoAll();toggle(p1)"
                          [ngbPopover]="popContentDelete" triggers="manual" #p1="ngbPopover" placement="top"
                        popoverClass="custom-rec-reserv-popover">Apply to all</button>
                        <!--Popover content for Delete start-->
                        <ng-template #popContentDelete>
                          <div class="">
                            <div class="hide" id="apply_all">
                              <p class="bold-12 product_trash product_trash_text">
                              Are you sure you want to apply these settings to all the locations selected?</p>
                              <div class="d-flex">
                                <button (click)="toggle(p1)" class="btn-secondary">
                                Cancel</button>
                                <button class="btn-primary ml-1" (click)="callsaveAction();toggle(p1)">
                                &nbsp;Apply&nbsp;</button>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td class="status-txt loc-switch">
                      <span class="loc_stat">
                        <label class="switch">
                          <input type="checkbox" [(ngModel)]="allEnrolled" class="imCheck"
                            (click)="changeEnrollFlag('All',$event)">
                          <span class="slider round"></span>
                        </label>
                        <span>{{allEnrolled?'Enrolled':'Not Enrolled'}}</span>
                      </span>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                }


                @if (ordersList?.length>0) {
                  @for (data of ordersList; track data; let i = $index) {
                    @if (!data.editModeOn) {
                      <tr>
                        <td class="status-txt loc-switch">
                          <div class="row">
                            <div class="col-md-2 topMargin ipadAlign"><label>
                              @if (data?.thisEleChecked) {
                                <input checked
                                  (click)="selectRadioFrRw(data?.fluContactId, $event)" type="checkbox" id="checkBox"
                                  class="row-selector">
                              }
                              @if (!data?.thisEleChecked) {
                                <input (click)="selectRadioFrRw(data?.fluContactId, $event)"
                                  type="checkbox" id="checkBox" class="row-selector">
                              }
                              <span class="checkmark"></span>
                            </label></div>
                            <div class="col-md-10 topMargintext">{{data?.locationName}}</div>
                          </div>
                        </td>
                        <td>
                          <span>{{data?.shippingAddresses?.line1}}, {{data?.shippingAddresses?.town}},
                          {{data?.shippingAddresses?.country?.isocode}}, {{data?.shippingAddresses?.postalCode}}</span>
                        </td>
                        <td class="status-txt">
                          <span> {{data.phoneNo}}</span>
                        </td>
                        <td class="status-txt loc-switch">
                          @if (!data.iscontactMethodThere) {
                            <span class="loc_stat">
                              <label class="switch"> @if (data.enrollflag) {
                                <input type="checkbox" class="imCheck"
                                  (click)="changeEnrollFlag(data?.fluContactId,false)" checked>
                              }
                              @if (!data.enrollflag) {
                                <input type="checkbox" class="imCheck" (click)="changeEnrollFlag(data?.fluContactId,true)"
                                  >
                              }
                              <span class="slider round"></span>
                            </label>
                            @if (data.enrollflag && !data.iscontactMethodThere) {
                              <span>Enrolled</span>
                            }
                            @if (!data.enrollflag && !data.iscontactMethodThere) {
                              <span>Not Enrolled</span>
                            }
                          </span>
                        }
                      </td>
                      <td class="status-txt">
                        <span> {{data.fullName}}</span>
                      </td>
                      <td class="status-txt">
                        @if (data.contactMethod=='INT') {
                          <span> {{data.email}}</span>
                        }
                        @if (data.contactMethod!='INT') {
                          <span> {{data.fax}}</span>
                        }
                      </td>
                      <td class="loc-edit">
                        <div class="show-msg alert-danger common-error" style="display: none;">
                          Please select the check box to make changes
                        </div>
                        @if (!editOn && !locationSelectorOn) {
                          <div><img class="editIcon"
                            src="/icons/{{baseSiteId}}/editIcon.png" alt="icon">
                            <a class="edit allctn-edit" href="javascript:void(0);" (click)="editModeOn(data.fluContactId)"
                            target="" title="Edit">Edit</a>
                          </div>
                        }
                        @if (editOn || locationSelectorOn) {
                          <div><img class="editIcon"
                            src="/icons/edit_disable.svg" alt="icon">
                            <a class="allctn-edit2" target="" title="Edit">Edit</a>
                          </div>
                        }
                      </td>
                    </tr>
                  }
                  @if (data.editModeOn) {
                    <tr id="{{'rowId'+i}}">
                      <td colspan="2">
                        <div class="row" #editContentSection>
                          <div class="col-md-10 editLocation">
                            <div class="row">
                              <div class="col-md-12 addresscontainer">
                                <h6 class="locationTitle">Location name</h6>
                                <p class="locationDesc">{{locationName}}<br />
                                {{addressDetails}}</p>
                                <p>
                                  @if (phoneErrorMsg) {
                                    <button disabled (click)="cancelEditSection(data.fluContactId)"
                                      class="btn-secondary mr-1 mb-1">
                                    Cancel</button>
                                  }
                                  @if (!phoneErrorMsg) {
                                    <button (click)="cancelEditSection(data.fluContactId)"
                                      class="btn-secondary mr-1 mb-1">
                                    Cancel</button>
                                  }
                                  @if (phoneErrorMsg || faxErrorMsg || emailErrorMsg || emailErrorMsg2 || nameErrorMsg) {
                                    <button
                                      disabled (click)="SaveAction()" class="btn-primary">
                                    &nbsp;Save&nbsp;</button>
                                  }
                                  @if (!phoneErrorMsg && !faxErrorMsg && !emailErrorMsg && !emailErrorMsg2 && !nameErrorMsg) {
                                    <button
                                      (click)="SaveAction()" class="btn-primary">
                                    &nbsp;Save&nbsp;</button>
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-1"></div>
                          <div class="col-md-1"></div>
                          <div class="col-md-1"></div>
                          <div class="col-md-1"></div>
                          <div class="col-md-4"></div>
                        </div>
                      </td>
                      <td scope="col" class="restCols_phone valignTop">
                        <input type="text" #phoneNumber
                          onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                          class="texttype"
                          (keyup)="validateFaxNumber(phoneNumber.value,'phone',dataSetForEdit.fluContactId)"
                          [(ngModel)]="dataSetForEdit.phoneNo" id="faxcontactmethod{{i}}" name="fax{{i}}">
                        @if (phoneErrorMsg) {
                          <p class="ml-2 redmsg" maxlength="10">This field is required</p>
                        }
                      </td>
                      <td scope="col" class="valignTop">
                        <div class="status-txt loc-switch">
                          <span class="loc_stat">
                            <label class="switch"> @if (dataSetForEdit.enrollflag) {
                              <input type="checkbox" class="imCheck"
                                (click)="changeEnrollFlag(dataSetForEdit?.fluContactId,false)"
                                checked>
                            }
                            @if (!dataSetForEdit.enrollflag) {
                              <input type="checkbox" class="imCheck"
                                (click)="changeEnrollFlag(dataSetForEdit?.fluContactId,true)"
                                >
                            }
                            <span class="slider round"></span>
                          </label>
                          @if (data.enrollflag) {
                            <span>Enrolled </span>
                          }
                          @if (!data.enrollflag) {
                            <span>Not Enrolled</span>
                          }
                        </span>
                      </div>
                    </td>
                    <td scope="col" class="restCols_phone valignTop">
                      <input class="texttype" type="text" #resContact [(ngModel)]="dataSetForEdit.fullName"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                        (keyup)="nameValidation(resContact.value)" name="servation_contact"><br />
                        @if (nameErrorMsg) {
                          <span class="redmsgFax">This field is required</span>
                        }
                      </td>
                      <td colspan="2" scope="col" class="restCols_phone valignTop">
                        <div class="row container">
                          <div class="col-md-12">
                            <p class="locationTitle">Email :<br />
                              <input type="radio" class="checkmark" id="radio-btn" class="radioChecked"
                                name="orderConfirmation1" (click)="cMethodElection('INT')" value="INT"
                                [(ngModel)]="dataSetForEdit.contactMethod" />
                              &nbsp;<span class="emailField"><input #emailVal class="texttype2"
                              (keyup)="validateEmailmethod(emailVal.value)" type="email"
                            [(ngModel)]="dataSetForEdit.email" name="servation_contact"></span><br />
                            @if (emailErrorMsg2) {
                              <span class="redmsgFax">This field is required</span>
                            }
                            @if (emailErrorMsg && !emailErrorMsg2) {
                              <span class="redmsgFax">Please enter the valid
                                email
                              address</span>
                            }
                          </p>
                          @if (dataSetForEdit?.disableFax) {
                            <p class="locationTitle">Fax:<br />
                              @if (dataSetForEdit.contactMethod!='INT') {
                                <input type="radio" class="checkmark" (click)="cMethodElection('fax')" id="radio-btn"
                                  name="orderConfirmation1" value="email"
                                  checked />
                              }
                              @if (dataSetForEdit.contactMethod=='INT') {
                                <input type="radio" id="radio-btn" (click)="cMethodElection('fax')"
                                  name="orderConfirmation1" value="email" />
                              }
                              &nbsp;<input #faxnumber class="texttype2"
                              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                              type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',dataSetForEdit.fluContactId)"
                              [(ngModel)]="dataSetForEdit.fax" name="servation_contact" /><br />
                              @if (faxErrorMsg) {
                                <span class="redmsgFax">This field is required</span>
                              }
                            </p>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              }
            }
            @if (ordersList?.length==0) {
              <tr>
                <td colspan="7" class="alignCenter">No matching locations</td>
              </tr>
            }

          </tbody>

        </table>


        <!--table ends-->
        <!--mobile view starts-->
        <div id="applyVaccineLocatorTable">

          <div class="mb-location">

            <div class="restCols">

              <div class="row">

                <div class="col-6 radioAlign"><label>

                  @if (!locationSelectorOn) {
                    <input type="checkbox" id="checkBox" (click)="applySettingAll()"
                      data-di-id="#checkBox">
                  }

                  @if (locationSelectorOn) {
                    <input type="checkbox" id="checkBox" checked (click)="applySettingAll()"
                      data-di-id="#checkBox">
                  }
                  <span class="checkmark"></span>

                </label>
              </div>

              <div class="col-6 topMargin-select">
                Location({{arrLength}})
              </div>

            </div>

          </div>

        </div>

        <div>

          @if (locationSelectorOn) {
            <div class="p-1 pb-2 bg-location">
              <div class="locationSelector locationSelector-height">
                <span>All locations selected({{arrLength}})</span>
                <div class="status-txt loc-switch st-outline">
                  <span class="loc_stat">
                    <label class="switch">
                      <input type="checkbox" [(ngModel)]="allEnrolled" class="imCheck" (click)="changeEnrollFlag('All',$event)">
                      <span class="slider round"></span>
                    </label>
                    <span>{{allEnrolled?'Enrolled':'Not Enrolled'}}</span>
                  </span>
                </div>
                <div id="AllBtn" class="loc-btn mob-loc-btn recursive-loc-btn mt-1">
                  <button class="btn-secondary cancel-mob">
                    <a (click)="cancelAllLocation()">Cancel</a></button>
                    <button class="btn btn-primary apply-mob" (click)="clickApplytoAll();toggle(p2)" [ngbPopover]="popContentDeleteMob" triggers="manual" #p2="ngbPopover" placement="top"
                      popoverClass="custom-rec-reserv-popover-mob">
                      Apply to all
                    </button>
                    <!--Popover content for Delete start-->
                    <ng-template #popContentDeleteMob>
                      <div class="">
                        <div class="hide" id="apply_all">
                          <p class="bold-12 product_trash product_trash_text">
                          Are you sure you want to apply these settings to all the locations selected?</p>
                          <div class="d-flex">
                            <button (click)="toggle(p2)" class="btn-secondary">
                            Cancel</button>
                            <button class="btn-primary ml-1" (click)="callsaveAction();toggle(p2)">
                            &nbsp;Apply&nbsp;</button>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            }

          </div>

          @if (ordersList?.length>0) {
            @for (data of ordersList; track data; let i = $index) {
              <section class="pt-3">
                @if (!data.editModeOn) {
                  <div>
                    <div class="row p-1">
                      <div class="col-6 mb-1">
                        <label class="col-title">
                          Select
                        </label>
                      </div>
                      <div class="col-6 mt-2 p-2 select-radio-div">
                        <label>
                          @if (data?.thisEleChecked) {
                            <input checked (click)="selectRadioFrRw(data?.fluContactId, $event)"
                              type="checkbox" id="checkBox" class="row-selector">
                          }
                          @if (!data?.thisEleChecked) {
                            <input (click)="selectRadioFrRw(data?.fluContactId, $event)"
                              type="checkbox" id="checkBox" class="row-selector">
                          }
                          <span class="checkmark ml-0"></span>
                        </label>
                      </div>
                      <div class="col-6">
                        <label class="col-title">
                          Location
                        </label>
                      </div>
                      <div class="col-6 mt-2 p-0">
                        <label class="desc">
                          {{data?.locationName}}
                        </label>
                      </div>
                      <div class="col-6">
                        <label class="col-title">
                          Address
                        </label>
                      </div>
                      <div class="col-6 mt-2 p-0">
                        <label class="desc">
                          {{data?.shippingAddresses?.line1}}, {{data?.shippingAddresses?.town}},
                          {{data?.shippingAddresses?.country?.isocode}}, {{data?.shippingAddresses?.postalCode}}
                        </label>
                      </div>
                      <div class="col-6">
                        <label class="col-title">
                          Phone
                        </label>
                      </div>
                      <div class="col-6 mt-2 phoneMobilePadding">
                        <label class="desc">
                          {{data.phoneNo}}
                        </label>
                      </div>
                      <div class="col-6">
                        <label class="col-title">
                          Status
                        </label>
                      </div>
                      <div class="col-6 status-txt loc-switch mt-3">
                        <span class="loc_stat">
                          <label class="switch"> @if (data.enrollflag) {
                            <input type="checkbox" class="imCheck"
                              (click)="changeEnrollFlag(data?.fluContactId,false)" checked>
                          }
                          @if (!data.enrollflag) {
                            <input type="checkbox" class="imCheck" (click)="changeEnrollFlag(data?.fluContactId,true)"
                              >
                          }
                          <span class="slider round"></span>
                        </label>
                        @if (data.enrollflag && !data.iscontactMethodThere) {
                          <span>Enrolled</span>
                        }
                        @if (!data.enrollflag && !data.iscontactMethodThere) {
                          <span>Not Enrolled</span>
                        }
                      </span>
                    </div>
                    <div class="col-6">
                      <label class="col-title">
                        Reservation Contact
                      </label>
                    </div>
                    <div class="col-6 mt-3 phoneMobilePadding">
                      @if (!editOn) {
                        <label class="desc">
                          {{data.fullName}}
                        </label>
                      }
                    </div>
                    <div class="col-6">
                      <label class="col-title">
                        Preferred Contact Method
                      </label>
                    </div>
                    <div class="col-6">
                      @if (data.contactMethod=='INT') {
                        <label class="col-title"> {{data?.email}}</label>
                      }
                      @if (data.contactMethod!='INT') {
                        <label class="col-title"> {{data?.fax}}</label>
                      }
                    </div>
                    <div class="col-12 text-center">
                      <div class="show-msg alert-danger common-error" style="display: none;">
                        Please select the check box to make changes
                      </div>
                      @if (!editOn && !locationSelectorOn) {
                        <div><img class="editIcon"
                          src="/icons/{{baseSiteId}}/editIcon.png" alt="icon">
                          <a class="edit allctn-edit" href="javascript:void(0);" (click)="editModeOn(data.fluContactId)"
                          target="" title="Edit">Edit</a>
                        </div>
                      }
                      @if (editOn || locationSelectorOn) {
                        <div><img class="editIcon"
                          src="/icons/edit_disable.svg" alt="icon">
                          <a class="allctn-edit2" target="" title="Edit">Edit</a>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (data.editModeOn) {
                <div id="{{'rowIdMob'+i}}">
                  <div class="row p-1">
                    <div class="col-6">
                      <label class="col-title">
                        Location
                      </label>
                    </div>
                    <div class="col-6 mt-2 p-0">
                      <label class="desc">
                        {{data?.locationName}}
                      </label>
                    </div>
                    <div class="col-6">
                      <label class="col-title">
                        Address
                      </label>
                    </div>
                    <div class="col-6 mt-2 p-0">
                      <label class="desc">
                        {{data?.shippingAddresses?.line1}}, {{data?.shippingAddresses?.town}},
                        {{data?.shippingAddresses?.country?.isocode}}, {{data?.shippingAddresses?.postalCode}}
                      </label>
                    </div>
                    <div class="col-6">
                      <label class="col-title">
                        Phone
                      </label>
                    </div>
                    <div class="col-6 mt-2 phoneMobilePadding">
                      @if (editOn ) {
                        <div class="row p-1">
                          <div scope="col-12 mt-2">
                            <input type="text" #phoneNumber
                              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                              class="texttype"
                              (keyup)="validateFaxNumber(phoneNumber.value,'phone',dataSetForEdit.fluContactId)"
                              [(ngModel)]="dataSetForEdit.phoneNo" id="faxcontactmethod{{i}}" name="fax{{i}}">
                            @if (phoneErrorMsg) {
                              <p class="ml-2 redmsg" maxlength="10">This field is required</p>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-6">
                      <label class="col-title">
                        Status
                      </label>
                    </div>
                    <div class="col-6 status-txt loc-switch mt-3">
                      <span class="loc_stat">
                        <label class="switch"> @if (dataSetForEdit.enrollflag) {
                          <input type="checkbox" class="imCheck"
                            (click)="changeEnrollFlag(dataSetForEdit?.fluContactId,false)" checked>
                        }
                        @if (!dataSetForEdit.enrollflag) {
                          <input type="checkbox" class="imCheck" (click)="changeEnrollFlag(dataSetForEdit?.fluContactId,true)"
                            >
                        }
                        <span class="slider round"></span>
                      </label>
                      @if (data.enrollflag) {
                        <span>Enrolled</span>
                      }
                      @if (!data.enrollflag) {
                        <span>Not Enrolled</span>
                      }
                    </span>
                  </div>
                  <div class="col-6">
                    <label class="col-title">
                      Reservation Contact
                    </label>
                  </div>
                  <div class="col-6 mt-3 phoneMobilePadding">
                    <div class="row p-1">
                      <div scope="col-12">
                        <input class="texttype" type="text" #resContact [(ngModel)]="dataSetForEdit.fullName"
                          onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                          (keyup)="nameValidation(resContact.value)" name="servation_contact"><br />
                          @if (nameErrorMsg) {
                            <span class="redmsgFax">This field is required</span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <label class="col-title">
                        Preferred Contact Method
                      </label>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col-md-12 pl-0">
                          <div class="locationTitle">Email:</div>
                          <div class="d-flex mb-1">
                            <input type="radio" class="checkmark" id="radio-btn" class="radioChecked"
                              name="orderConfirmation" (click)="cMethodElection('INT')" value="INT"
                              [(ngModel)]="dataSetForEdit.contactMethod" />
                            &nbsp;<span class="emailField"><input #emailVal class="texttype2"
                            (keyup)="validateEmailmethod(emailVal.value)" type="email"
                          [(ngModel)]="dataSetForEdit.email" name="servation_contact"></span><br />
                          @if (emailErrorMsg2) {
                            <span class="redmsgFax">This field is required</span>
                          }
                          @if (emailErrorMsg && !emailErrorMsg2) {
                            <span class="redmsgFax">Please enter the valid
                              email
                            address</span>
                          }
                        </div>
                        @if (dataSetForEdit?.disableFax) {
                          <div class="locationTitle">Fax:</div>
                        }
                        @if (dataSetForEdit?.disableFax) {
                          <div class="d-flex mb-1">
                            @if (dataSetForEdit.contactMethod!='INT') {
                              <input type="radio" class="checkmark" (click)="cMethodElection('fax')" id="radio-btn"
                                name="orderConfirmation" value="email"
                                checked />
                            }
                            @if (dataSetForEdit.contactMethod=='INT') {
                              <input type="radio" id="radio-btn" (click)="cMethodElection('fax')"
                                name="orderConfirmation" value="email" />
                            }
                            &nbsp;<input #faxnumber class="texttype2"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',dataSetForEdit.fluContactId)"
                            [(ngModel)]="dataSetForEdit.fax" name="servation_contact" /><br />
                            @if (faxErrorMsg) {
                              <span class="redmsgFax">This field is required</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="col-12 text-center">
                    @if (phoneErrorMsg) {
                      <button disabled (click)="cancelEditSection(data.fluContactId)"
                        class="btn-secondary mr-1 mb-1">
                        Cancel
                      </button>
                    }
                    @if (!phoneErrorMsg) {
                      <button (click)="cancelEditSection(data.fluContactId)"
                        class="btn-secondary mr-1 mb-1">
                        Cancel
                      </button>
                    }
                    @if (phoneErrorMsg || faxErrorMsg || emailErrorMsg || emailErrorMsg2 || nameErrorMsg) {
                      <button
                        disabled (click)="SaveAction()" class="btn-primary">
                        &nbsp;Save&nbsp;
                      </button>
                    }
                    @if (!phoneErrorMsg && !faxErrorMsg && !emailErrorMsg && !emailErrorMsg2 && !nameErrorMsg) {
                      <button
                        (click)="SaveAction()" class="btn-primary">
                        &nbsp;Save&nbsp;
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
          </section>
        }
      }
      @if (ordersList?.length==0) {
        <div class="alignCenter">No matching locations</div>
      }

    </div>

  </div>
</section>
</div>

</section>
</section>
